import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '~/components/ui/alert-dialog';

type ConfirmationDialogProps = {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  triggerButton?: React.ReactElement;
  onConfirmClick?: () => void;
  onCancelClick?: () => void;
  defaultOpen?: boolean;
};

export function ConfirmationDialog({
  title,
  description,
  confirmLabel,
  cancelLabel,
  triggerButton,
  onConfirmClick,
  onCancelClick,
  defaultOpen = false,
}: ConfirmationDialogProps) {
  return (
    <AlertDialog defaultOpen={defaultOpen}>
      {triggerButton && !defaultOpen ? (
        <AlertDialogTrigger asChild>{triggerButton}</AlertDialogTrigger>
      ) : (
        // Hidden dummy trigger to satisfy Radix requirement
        <AlertDialogTrigger asChild>
          <span className="sr-only">Open</span>
        </AlertDialogTrigger>
      )}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={onCancelClick ? onCancelClick : undefined}
          >
            {cancelLabel}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirmClick}>
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
